import React from 'react';
import { Shield, Target, Layers, Headphones, BookOpen, Lock } from 'lucide-react';
import { benefitsData } from '../data/mock';

const iconMap = {
  Shield,
  Target,
  Layers,
  Headphones,
  BookOpen,
  Lock
};

export default function Benefits() {
  return (
    <section className="py-20 bg-gray-50">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
            Trade with Confidence
          </h2>
          <p className="text-lg text-gray-600">
            Everything you need for successful trading in one powerful platform
          </p>
        </div>

        {/* Benefits Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {benefitsData.map((benefit) => {
            const Icon = iconMap[benefit.icon];
            return (
              <div 
                key={benefit.id}
                className="group bg-white rounded-xl p-8 hover:shadow-lg transition-all duration-300 border border-gray-100"
              >
                <div className="flex items-start space-x-4">
                  <div className="flex-shrink-0">
                    <div className="w-14 h-14 bg-[#ff444f]/10 rounded-xl flex items-center justify-center group-hover:bg-[#ff444f] group-hover:scale-110 transition-all duration-300">
                      <Icon className="w-7 h-7 text-[#ff444f] group-hover:text-white transition-colors" />
                    </div>
                  </div>
                  <div className="flex-1">
                    <h3 className="text-lg font-bold text-gray-900 mb-2 group-hover:text-[#ff444f] transition-colors">
                      {benefit.title}
                    </h3>
                    <p className="text-gray-600 leading-relaxed">
                      {benefit.description}
                    </p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
